__turbopack_context__.v({
  "actions": "marketing-module__T5Pr6W__actions",
  "agentCard": "marketing-module__T5Pr6W__agentCard",
  "agentGrid": "marketing-module__T5Pr6W__agentGrid",
  "agentSymbol": "marketing-module__T5Pr6W__agentSymbol",
  "arrive": "marketing-module__T5Pr6W__arrive",
  "bag": "marketing-module__T5Pr6W__bag",
  "bottle": "marketing-module__T5Pr6W__bottle",
  "buddyMessage": "marketing-module__T5Pr6W__buddyMessage",
  "buddyReply": "marketing-module__T5Pr6W__buddyReply",
  "buddyTeam": "marketing-module__T5Pr6W__buddyTeam",
  "cartFrame": "marketing-module__T5Pr6W__cartFrame",
  "cartTotal": "marketing-module__T5Pr6W__cartTotal",
  "catalogConnector": "marketing-module__T5Pr6W__catalogConnector",
  "catalogSources": "marketing-module__T5Pr6W__catalogSources",
  "chatFrame": "marketing-module__T5Pr6W__chatFrame",
  "chatHint": "marketing-module__T5Pr6W__chatHint",
  "chatProduct": "marketing-module__T5Pr6W__chatProduct",
  "commerceScene": "marketing-module__T5Pr6W__commerceScene",
  "connectedStore": "marketing-module__T5Pr6W__connectedStore",
  "demoAction": "marketing-module__T5Pr6W__demoAction",
  "demoDisclaimer": "marketing-module__T5Pr6W__demoDisclaimer",
  "demoSuccess": "marketing-module__T5Pr6W__demoSuccess",
  "demoTabs": "marketing-module__T5Pr6W__demoTabs",
  "discoveryFrame": "marketing-module__T5Pr6W__discoveryFrame",
  "eyebrow": "marketing-module__T5Pr6W__eyebrow",
  "finaleFrame": "marketing-module__T5Pr6W__finaleFrame",
  "hero": "marketing-module__T5Pr6W__hero",
  "heroCopy": "marketing-module__T5Pr6W__heroCopy",
  "heroGrid": "marketing-module__T5Pr6W__heroGrid",
  "heroVisual": "marketing-module__T5Pr6W__heroVisual",
  "insightFrame": "marketing-module__T5Pr6W__insightFrame",
  "insightLabel": "marketing-module__T5Pr6W__insightLabel",
  "insightNote": "marketing-module__T5Pr6W__insightNote",
  "knowledgeNote": "marketing-module__T5Pr6W__knowledgeNote",
  "lead": "marketing-module__T5Pr6W__lead",
  "marketFooter": "marketing-module__T5Pr6W__marketFooter",
  "marketIntro": "marketing-module__T5Pr6W__marketIntro",
  "marketLink": "marketing-module__T5Pr6W__marketLink",
  "marketProducts": "marketing-module__T5Pr6W__marketProducts",
  "marketScene": "marketing-module__T5Pr6W__marketScene",
  "messageIcon": "marketing-module__T5Pr6W__messageIcon",
  "notes": "marketing-module__T5Pr6W__notes",
  "partnerNote": "marketing-module__T5Pr6W__partnerNote",
  "playButton": "marketing-module__T5Pr6W__playButton",
  "previewCaption": "marketing-module__T5Pr6W__previewCaption",
  "previewProductArt": "marketing-module__T5Pr6W__previewProductArt",
  "primary": "marketing-module__T5Pr6W__primary",
  "productArt": "marketing-module__T5Pr6W__productArt",
  "productCard": "marketing-module__T5Pr6W__productCard",
  "productGrid": "marketing-module__T5Pr6W__productGrid",
  "productIdentity": "marketing-module__T5Pr6W__productIdentity",
  "productPreview": "marketing-module__T5Pr6W__productPreview",
  "productSection": "marketing-module__T5Pr6W__productSection",
  "recommendedProduct": "marketing-module__T5Pr6W__recommendedProduct",
  "sceneCaption": "marketing-module__T5Pr6W__sceneCaption",
  "sceneConnector": "marketing-module__T5Pr6W__sceneConnector",
  "sceneContext": "marketing-module__T5Pr6W__sceneContext",
  "sceneHeader": "marketing-module__T5Pr6W__sceneHeader",
  "sceneMessage": "marketing-module__T5Pr6W__sceneMessage",
  "sceneTrack": "marketing-module__T5Pr6W__sceneTrack",
  "searchPreview": "marketing-module__T5Pr6W__searchPreview",
  "sectionHeading": "marketing-module__T5Pr6W__sectionHeading",
  "shelf": "marketing-module__T5Pr6W__shelf",
  "shelfItem": "marketing-module__T5Pr6W__shelfItem",
  "shopperMessage": "marketing-module__T5Pr6W__shopperMessage",
  "shopperQuestion": "marketing-module__T5Pr6W__shopperQuestion",
  "storefront": "marketing-module__T5Pr6W__storefront",
  "storefrontTitle": "marketing-module__T5Pr6W__storefrontTitle",
  "storyAgents": "marketing-module__T5Pr6W__storyAgents",
  "storyControls": "marketing-module__T5Pr6W__storyControls",
  "storyFrame": "marketing-module__T5Pr6W__storyFrame",
  "storyHeading": "marketing-module__T5Pr6W__storyHeading",
  "storyLayout": "marketing-module__T5Pr6W__storyLayout",
  "storyLead": "marketing-module__T5Pr6W__storyLead",
  "storySection": "marketing-module__T5Pr6W__storySection",
  "storyTheater": "marketing-module__T5Pr6W__storyTheater",
  "teamCenter": "marketing-module__T5Pr6W__teamCenter",
  "typing": "marketing-module__T5Pr6W__typing",
  "vase": "marketing-module__T5Pr6W__vase",
});
